

export class ApplicationSubMenuOutputWithStatus implements IApplicationSubMenuOutputWithStatus {
    /** The auto-generated id of the tbl_application_sub_menu */
    application_sub_menu_id!: number;
    /** The sub menu name with 100 character limit */
    menu_name!: string;
    /** The sub menu icon with 2048 character limit */
    menu_url!: string;
    /** The sub menu type must be "OVERVIEW" or "DETAIL" */
    screen_type!: string;
    /** The index_number */
    index_number!: number;
    /** Manage status of user. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IApplicationSubMenuOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application_sub_menu_id = _data["application_sub_menu_id"];
            this.menu_name = _data["menu_name"];
            this.menu_url = _data["menu_url"];
            this.screen_type = _data["screen_type"];
            this.index_number = _data["index_number"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ApplicationSubMenuOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationSubMenuOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application_sub_menu_id"] = this.application_sub_menu_id;
        data["menu_name"] = this.menu_name;
        data["menu_url"] = this.menu_url;
        data["screen_type"] = this.screen_type;
        data["index_number"] = this.index_number;
        data["status"] = this.status;
        return data; 
    }
}

export interface IApplicationSubMenuOutputWithStatus {
    /** The auto-generated id of the tbl_application_sub_menu */
    application_sub_menu_id: number;
    /** The sub menu name with 100 character limit */
    menu_name: string;
    /** The sub menu icon with 2048 character limit */
    menu_url: string;
    /** The sub menu type must be "OVERVIEW" or "DETAIL" */
    screen_type: string;
    /** The index_number */
    index_number: number;
    /** Manage status of user. 0 For De-active, 1 For Active */
    status: number;
}

